/**
 * O que a tela de custos DIZ — fora do componente, onde o teste alcança. A
 * conta é do servidor; aqui só se soma a faixa do topo e se escreve o que o
 * número não inclui.
 */
import type { CustoDoEquipamento } from './api';

export interface TotaisDoPeriodo {
  readonly total: number;
  readonly combustivel: number;
  readonly estoque: number;
  readonly terceiros: number;
  readonly maoDeObra: number;
  readonly semPreco: number;
  readonly horasMaoDeObra: number;
  readonly horasSemValor: number;
  /* 0096 */
  readonly depreciacao: number;
  readonly indiretoRateado: number;
  /** Direto + depreciação + indireto; servidor anterior: o direto. */
  readonly custoTotal: number;
}

export function totaisDoPeriodo(linhas: readonly CustoDoEquipamento[]): TotaisDoPeriodo {
  return linhas.reduce<TotaisDoPeriodo>(
    (t, l) => ({
      total: t.total + l.total,
      combustivel: t.combustivel + l.combustivel,
      estoque: t.estoque + l.estoque,
      terceiros: t.terceiros + l.terceiros,
      maoDeObra: t.maoDeObra + (l.maoDeObra ?? 0),
      semPreco: t.semPreco + l.semPreco,
      horasMaoDeObra: t.horasMaoDeObra + l.horasMaoDeObra,
      horasSemValor: t.horasSemValor + (l.horasSemValor ?? 0),
      depreciacao: t.depreciacao + (l.depreciacao ?? 0),
      indiretoRateado: t.indiretoRateado + (l.indiretoRateado ?? 0),
      custoTotal: t.custoTotal + (l.custoTotal ?? l.total),
    }),
    {
      total: 0, combustivel: 0, estoque: 0, terceiros: 0, maoDeObra: 0, semPreco: 0, horasMaoDeObra: 0, horasSemValor: 0,
      depreciacao: 0, indiretoRateado: 0, custoTotal: 0,
    },
  );
}

/**
 * O que a faixa do topo mostra, pelo estado da consulta (revisão R01/R02,
 * `painel-custos-kpi-zero`). Os totais saíam de `data?.equipamentos ?? []`:
 * enquanto a consulta carregava, e depois que falhava, os quatro cards
 * mostravam "R$ 0,00" como se o custo fosse zero. Sem resposta não há total:
 * há esqueleto, ou a falha com o que fazer.
 *
 * A falha vence, como na tabela logo abaixo: um total antigo ao lado de "não
 * foi possível carregar" seria de novo um número que ninguém confirmou.
 */
export type EstadoDaFaixa = 'carregando' | 'falhou' | 'pronta';

export function estadoDaFaixa(consulta: { readonly data: unknown; readonly isError: boolean }): EstadoDaFaixa {
  if (consulta.isError) return 'falhou';
  return consulta.data === undefined ? 'carregando' : 'pronta';
}

/**
 * A frase que acompanha o total: o v6 escreve o risco da ferramenta 4 — "chamar
 * custo parcial de custo total ou margem final".
 *
 * Desde a 0096 o servidor apura o custo TOTAL (direto + depreciação + indireto
 * rateado) e manda a lista do que ficou fora (`ausencias`) com as frases
 * únicas — a da mão de obra sem valor, a da depreciação ausente, a do indireto
 * sem lançamento. A tela escreve a lista como veio (`fraseDoCustoTotal`), e só
 * diz "completo" quando ela está vazia.
 */
export { fraseDoCustoTotal as oQueOTotalNaoInclui } from './margem';
